import React, { useCallback, useEffect, useState } from 'react';
import {
  Content,
  Row,
  Col,
  Text,
  Tabs,
  Title,
  ModalLayout,
  Descriptions,
} from 'components';
import { Button, Tag, Input, DatePicker, Select } from 'antd';
// import Sort from 'assets/icon/sort_icon.png';
import { OrderItem } from 'routes/store.routes/components';
import moment from 'moment';
import dayjs from 'dayjs';
import 'moment/locale/ko';
import { stringToMoneyFormat, getDateRange } from 'utils';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';

const PAYMENT_STATE = [
  {
    label: '결제완료',
    value: 'COMPLETED',
  },
  {
    label: '결제취소',
    value: 'REFUNDED',
  },
];

const OrderListPresenter = ({
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  data,
  tabKey,
  filterKey,
  userInfo,
  isOpened,
  modalData,
  modalType,
  onDevice,
  onClose,
  onSelect,
  onFilterSelect,
  onSubmit,
  onChangeDay,
  MOMENT_FORMAT,
  startOfToday,
  endOfToday,
  setStartOfDay,
  setEndOfDay,
  onUpdatePaymentState,
}) => {
  /* ===== STATE ===== */
  const [orderList, setOrderList] = useState([]);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [refundReason, setRefundReason] = useState('');

  const [searchInputValue, setSearchInputValue] = React.useState({});
  /* ===== VARIABLE ===== */
  // console.log('filterKey', filterKey);
  // console.log('modalData', modalData);
  // console.log('data', data);
  // console.log('searchInputValue', searchInputValue);
  const styles = {
    button: {
      width: '33%',
      height: 75,
      borderRadius: 0,
      fontSize: 20,
      fontWeight: 700,
    },
    searchButton: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 150,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };
  const handleChange = (key, value) => {
    setSearchInputValue((prev) => ({
      ...prev,
      [key]: value,
    }));
    // console.log('key', key);
    // console.log('value', value);

    if (key === 'joinStartDate') {
      setStartOfDay(moment(value, 'YYYY-MM-DD').startOf('day').unix());
    }
    if (key === 'joinEndDate') {
      setEndOfDay(moment(value, 'YYYY-MM-DD').endOf('day').unix());
    }
  };

  const onSearch = () => {
    if (!searchInputValue) return false;
    const { searchKey, searchValue, joinStartDate, joinEndDate } =
      searchInputValue;

    // 초기 데이터
    let filteredOrders = data;

    // 회원별, 주문별 검색
    if (searchKey && searchValue) {
      filteredOrders = filteredOrders?.filter((order) => {
        if (searchKey === 'account')
          return order?.user?.user_account?.includes(searchValue);
        if (searchKey === 'name')
          return order?.user?.user_name?.includes(searchValue);
        if (searchKey === 'phone')
          return order?.user?.user_phone?.includes(searchValue);
        if (searchKey === 'order_id')
          return order?.order_id?.toString() === searchValue;
        return true;
      });
    }

    // 날짜별 검색
    if (joinStartDate || joinEndDate) {
      const startDate = joinStartDate
        ? moment(joinStartDate, 'YYYY-MM-DD')
        : null;
      const endDate = joinEndDate ? moment(joinEndDate, 'YYYY-MM-DD') : null;

      filteredOrders = filteredOrders?.filter((order) => {
        const orderDate = moment(order.created_at * 1000); // UNIX timestamp를 Date로 변환
        if (startDate && !endDate) return orderDate.isSameOrAfter(startDate);
        if (!startDate && endDate) return orderDate.isSameOrBefore(endDate);
        if (startDate && endDate)
          return orderDate.isBetween(startDate, endDate, 'day', '[]');
        return true;
      });
    }
    renderTabData(filteredOrders);
    // console.log('filteredOrders', filteredOrders);
    // 업데이트
  };
  // console.log('OrderList', orderList);

  const formItem = [
    {
      label: '검색어',
      form: [
        {
          input: (
            <Select
              size="large"
              value={searchInputValue?.searchKey || null}
              placeholder="검색 기준을 선택해주세요."
              options={[
                { label: '회원아이디', value: 'account' },
                { label: '회원명', value: 'name' },
                { label: '전화번호', value: 'phone' },
                { label: '주문번호', value: 'order_id' },
              ]}
              style={{ ...styles.form.input.large }}
              onChange={(e) => handleChange('searchKey', e)}
            />
          ),
        },
        {
          input: (
            <Input
              size="large"
              placeholder="검색어를 입력해주세요"
              style={{ ...styles.form.input.large }}
              value={searchInputValue?.searchValue}
              onChange={(e) => handleChange('searchValue', e.target.value)}
            />
          ),
        },
      ],
    },
    {
      label: '주문일',
      form: [
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                const [start, end] = getDateRange(0);

                handleChange(
                  'joinStartDate',
                  moment(start).format('YYYY-MM-DD'),
                );
                handleChange('joinEndDate', moment(end).format('YYYY-MM-DD'));
              }}
            >
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                const [start, end] = getDateRange(7);

                handleChange(
                  'joinStartDate',
                  moment(start).format('YYYY-MM-DD'),
                );
                handleChange('joinEndDate', moment(end).format('YYYY-MM-DD'));
              }}
            >
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                const [start, end] = getDateRange(30);

                handleChange(
                  'joinStartDate',
                  moment(start).format('YYYY-MM-DD'),
                );
                handleChange('joinEndDate', moment(end).format('YYYY-MM-DD'));
              }}
            >
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button
              size="large"
              style={{ ...styles.form.button }}
              onClick={() => {
                const [start, end] = getDateRange(90);

                handleChange(
                  'joinStartDate',
                  moment(start).format('YYYY-MM-DD'),
                );
                handleChange('joinEndDate', moment(end).format('YYYY-MM-DD'));
              }}
            >
              3개월
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
                {...(searchInputValue?.joinStartDate
                  ? {
                      value: searchInputValue?.joinStartDate
                        ? dayjs(searchInputValue?.joinStartDate)
                        : '',
                    }
                  : {})}
                onChange={(date, dateString) =>
                  handleChange('joinStartDate', dateString)
                }
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
                {...(searchInputValue?.joinEndDate
                  ? {
                      value: searchInputValue?.joinEndDate
                        ? dayjs(searchInputValue?.joinEndDate)
                        : '',
                    }
                  : {})}
                onChange={(date, dateString) =>
                  handleChange('joinEndDate', dateString)
                }
              />
            </>
          ),
        },
      ],
    },
  ];
  /**
   * 환불 사유 입력 모달 핸들러
   */
  const handleRefundModal = useCallback(
    (status) => {
      if (status === 'CANCELLED') {
        setIsRefundModalOpen(true);
      } else {
        onSubmit(modalData?.order_route, modalData?.order_id, status);
      }
    },
    [modalData, onSubmit],
  );

  /**
   * 환불 모달 확인 핸들러
   */
  const handleRefundSubmit = useCallback(() => {
    if (!refundReason.trim()) {
      alert('환불 사유를 입력해주세요.');
      return;
    }

    // 환불 사유와 함께 상태 변경
    onSubmit(
      modalData?.order_route,
      modalData?.order_id,
      'CANCELLED',
      modalData?.payment_info,
      refundReason,
    );
    setRefundReason(''); // 입력 초기화
    setIsRefundModalOpen(false); // 모달 닫기
  }, [modalData, onSubmit, refundReason]);

  const renderTabData = useCallback(
    (filteredData = null) => {
      const sourceData = filteredData || data;
      const tab = [
        { key: 'READY', label: `대기중` },
        { key: 'PREPARING', label: `조리중` },
        { key: 'COMPLETED', label: `완료` },
        { key: 'DELIVERING', label: `배달중` },
        { key: 'DELIVERED', label: `배달완료` },
        { key: 'CANCELLED', label: `취소됨` },
      ];

      const newData = tab?.map((_item) => ({
        ..._item,
        data: sourceData?.filter(
          (_subitem) => _item.key === _subitem.order_status,
        ),
      }));

      const list =
        tabKey === 'all'
          ? newData
          : newData?.filter((item) => item.key === tabKey);
      setOrderList(list);
    },
    [tabKey, data],
  );

  const handleReset = () => {
    setSearchInputValue();
    renderTabData();
  };
  /* ===== HOOKS ===== */

  useEffect(() => {
    renderTabData();
  }, [renderTabData]);

  useEffect(() => {
    setSearchInputValue();
  }, [tabKey]);

  // console.log('modalData', modalData);
  /* ===== RENDER ===== */

  return (
    <>
      {userInfo?.store_status === 'OPEN' ? (
        <Content maxWidth={'100%'} padding={0} backgroundColor="none">
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                {/* 상단 KIOSK, APP, POS 탭 */}
                <div
                  style={{
                    borderTop: '1px  solid',
                    borderColor: '#E5E5E5',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Tabs
                    items={[
                      { key: 'ALL', label: 'TODAY' },
                      { key: 'KIOSK', label: 'KIOSK' },
                      { key: 'APP', label: 'APP' },
                      { key: 'POS', label: 'POS' },
                      { key: 'REFUNDED', label: '전체환불이력' },
                      { key: 'ALLORDER', label: '전체주문이력' },
                    ]}
                    activeKey={filterKey}
                    onChange={(key) => onFilterSelect(key)}
                    activeColor={'#0F6CBD'}
                    style={{ fontSize: 18, marginBottom: 10 }}
                  />
                </div>
                <div
                  style={{
                    borderBottom: '1px solid',
                    padding: '5px 0',
                    borderColor: '#E5E5E5',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <div>
                    <Tabs
                      items={[
                        {
                          key: 'all',
                          label: `전체(${data?.length || 0})`,
                        },
                        {
                          key: 'READY',
                          label: `대기중(${
                            data?.filter(
                              (item) => item.order_status === 'READY',
                            ).length || 0
                          })`,
                        },
                        {
                          key: 'PREPARING',
                          label: `조리중(${
                            data?.filter(
                              (item) => item.order_status === 'PREPARING',
                            ).length || 0
                          })`,
                        },
                        {
                          key: 'COMPLETED',
                          label: `완료(${
                            data?.filter(
                              (item) => item.order_status === 'COMPLETED',
                            ).length || 0
                          })`,
                        },
                        {
                          key: 'DELIVERING',
                          label: `배송중(${
                            data?.filter(
                              (item) => item.order_status === 'DELIVERING',
                            ).length || 0
                          })`,
                        },
                        {
                          key: 'DELIVERED',
                          label: `배송완료(${
                            data?.filter(
                              (item) => item.order_status === 'DELIVERED',
                            ).length || 0
                          })`,
                        },
                        {
                          key: 'CANCELLED',
                          label: `취소됨(${
                            data?.filter(
                              (item) => item.order_status === 'CANCELLED',
                            ).length || 0
                          })`,
                        },
                      ]}
                      activeKey={tabKey}
                      onChange={(e) => onSelect(e)}
                      activeColor={'#0F6CBD'}
                      fullscreen={false}
                      layoutStyle={{ border: 'none' }}
                      style={{ fontSize: 18 }}
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Button
                      type="primary"
                      size="small"
                      style={{
                        width: 120,
                        height: 40,
                        fontSize: 14,
                        fontWeight: 600,
                        backgroundColor: '#FF4D4F',
                        borderColor: '#FF4D4F',
                      }}
                      onClick={() => {
                        onDevice('unsubscribe');
                      }}
                    >
                      영업 종료
                    </Button>
                    {/* <Text size={16} weight={500} color={'#595959'}>
                      정렬
                    </Text>
                    <div>
                      <img
                        src={Sort}
                        alt="정렬"
                        style={{ width: '100%', height: '100%' }}
                      />
                    </div> */}
                  </div>
                </div>
              </Content>
            </Col>
          </Row>
          {(filterKey === 'ALLORDER' || filterKey === 'REFUNDED') && (
            <Row>
              <Col span={24} style={{ textAlign: 'right', padding: 20 }}>
                <Title
                  level={5}
                  align="right"
                  style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                  }}
                  subButton={
                    <span>
                      <Button onClick={() => onChangeDay('today')}>
                        오늘로
                      </Button>
                    </span>
                  }
                >
                  <Button
                    shape="circle"
                    type="default"
                    size="small"
                    style={{ margin: '0 10px' }}
                    onClick={() => onChangeDay('prev')}
                  >
                    <ArrowLeftOutlined />
                  </Button>
                  {moment.unix(startOfToday).format(MOMENT_FORMAT) +
                    '~' +
                    moment.unix(endOfToday).format(MOMENT_FORMAT)}
                  <Button
                    shape="circle"
                    type="default"
                    size="small"
                    style={{ margin: '0 10px' }}
                    onClick={() => onChangeDay('next')}
                  >
                    <ArrowRightOutlined />
                  </Button>
                </Title>
              </Col>
              <Col x={24}>
                <Content maxWidth={'100%'} padding={20}>
                  {formItem.map((_item, _index) => (
                    <div
                      key={`form_${_index}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '10px 0px',
                      }}
                    >
                      <div
                        style={{ width: 120, fontSize: 13, fontWeight: 400 }}
                      >
                        <label>{_item.label}</label>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {_item.form.map((_subitem, _subkey) => (
                          <React.Fragment key={`input_${_subkey}`}>
                            {_subitem.input}
                          </React.Fragment>
                        ))}
                      </div>
                    </div>
                  ))}

                  {/* 검색/초기화 버튼 */}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: '100%',
                      marginTop: 48,
                    }}
                  >
                    <Button
                      size="large"
                      type="primary"
                      style={styles?.searchButton}
                      onClick={() => onSearch()}
                    >
                      검색
                    </Button>
                    <Button
                      size="large"
                      style={styles?.searchButton}
                      onClick={() => handleReset()}
                    >
                      초기화
                    </Button>
                  </div>
                </Content>
              </Col>
            </Row>
          )}
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={20} backgroundColor="none">
                {/* 주문 현황 */}
                <Content maxWidth={'100%'} padding={'25px 0px'}>
                  <ul
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                  >
                    <li style={{ padding: '0px 60px' }}>
                      <Text size={24} weight={700} color={'#6A6A6A'}>
                        주문현황
                      </Text>
                      <Text
                        size={18}
                        weight={400}
                        color={'#595959'}
                        style={{ marginTop: 9 }}
                      >
                        {filterKey === 'ALLORDER'
                          ? '전체주문현황'
                          : moment().format('YYYY년 MM월 DD일(ddd)')}
                      </Text>
                    </li>

                    <li
                      style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                      }}
                    >
                      <div
                        style={{
                          padding: '0px 60px',
                          borderRight: '1px solid #EDEDED',
                        }}
                      >
                        <Text size={18} weight={700} color={'#6A6A6A'}>
                          주문 수
                        </Text>
                        <Text size={34} weight={300} color={'#595959'}>
                          {stringToMoneyFormat(data?.length, '건')}
                        </Text>
                      </div>
                      <div
                        style={{
                          padding: '0px 60px',
                          borderRight: '1px solid #EDEDED',
                        }}
                      >
                        <Text size={18} weight={700} color={'#6A6A6A'}>
                          배달
                        </Text>
                        <Text size={34} weight={300} color={'#595959'}>
                          {stringToMoneyFormat(
                            data?.filter((_item) => _item.type === 'ORDER')
                              .length,
                            '건',
                          )}
                        </Text>
                      </div>
                      <div
                        style={{
                          padding: '0px 60px',
                          borderRight: '1px solid #EDEDED',
                        }}
                      >
                        <Text size={18} weight={700} color={'#6A6A6A'}>
                          매장이용
                        </Text>
                        <Text size={34} weight={300} color={'#595959'}>
                          {stringToMoneyFormat(
                            data?.filter((_item) => _item.type === 'GENERAL')
                              .length,
                            '건',
                          )}
                        </Text>
                      </div>
                      <div
                        style={{
                          padding: '0px 60px',
                          borderRight: '1px solid #EDEDED',
                        }}
                      >
                        <Text size={18} weight={700} color={'#6A6A6A'}>
                          포장이용
                        </Text>
                        <Text size={34} weight={300} color={'#595959'}>
                          {stringToMoneyFormat(
                            data?.filter((_item) => _item.type === 'TAKE_OUT')
                              .length,
                            '건',
                          )}
                        </Text>
                      </div>
                    </li>
                  </ul>
                  <ul
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginTop: 10,
                      paddingTop: 10,
                      borderTop: '1px solid #ececf0',
                    }}
                  >
                    <li>
                      <div
                        style={{
                          padding: '0px 60px',
                          borderRight: '1px solid #EDEDED',
                        }}
                      >
                        <Text size={18} weight={700} color={'#6A6A6A'}>
                          매출
                        </Text>
                        <Text size={34} weight={300} color={'#595959'}>
                          {stringToMoneyFormat(
                            data?.reduce((acc, cur) => {
                              if (cur?.payment_state === 'COMPLETED') {
                                acc += cur?.totalPrice;
                              }
                              return acc;
                            }, 0),
                            '원',
                          )}
                        </Text>
                      </div>
                    </li>
                    <li>
                      <div
                        style={{
                          padding: '0px 60px',
                          borderRight: '1px solid #EDEDED',
                        }}
                      >
                        <Text size={18} weight={700} color={'#6A6A6A'}>
                          환불
                        </Text>
                        <Text size={34} weight={300} color={'#595959'}>
                          {stringToMoneyFormat(
                            data?.reduce((acc, cur) => {
                              if (cur?.payment_state === 'REFUNDED') {
                                acc += cur?.totalPrice;
                              }
                              return acc;
                            }, 0),
                            '원',
                          )}
                        </Text>
                      </div>
                    </li>
                    <li>
                      <div
                        style={{
                          padding: '0px 60px',
                          borderRight: '1px solid #EDEDED',
                        }}
                      >
                        <Text size={18} weight={700} color={'#6A6A6A'}>
                          할인
                        </Text>
                        <Text size={34} weight={300} color={'#595959'}>
                          {stringToMoneyFormat(
                            data?.reduce((acc, cur) => {
                              const discount =
                                cur?.payment_state === 'COMPLETED'
                                  ? Math.abs(cur?.final_discount)
                                  : 0;
                              return acc + discount;
                            }, 0),
                            '원',
                          )}
                        </Text>
                      </div>
                    </li>

                    <li>
                      <div
                        style={{
                          padding: '0px 60px',
                          borderRight: '1px solid #EDEDED',
                        }}
                      >
                        <Text size={18} weight={700} color={'#6A6A6A'}>
                          사용 포인트
                        </Text>
                        <Text size={34} weight={300} color={'#595959'}>
                          {stringToMoneyFormat(
                            data?.reduce((acc, cur) => {
                              if (cur?.payment_state === 'COMPLETED') {
                                acc += cur?.use_point;
                              }
                              return acc;
                            }, 0),
                            '원',
                          )}
                        </Text>
                      </div>
                    </li>

                    <li>
                      <div
                        style={{
                          padding: '0px 60px',
                          borderRight: '1px solid #EDEDED',
                        }}
                      >
                        <Text size={18} weight={700} color={'#6A6A6A'}>
                          선물 쿠폰
                        </Text>
                        <Text size={34} weight={300} color={'#595959'}>
                          {stringToMoneyFormat(
                            data?.reduce((acc, cur) => {
                              if (
                                cur?.payment_state === 'COMPLETED' &&
                                Array.isArray(cur?.present_info)
                              ) {
                                acc -= cur?.present_info.reduce(
                                  (couponAcc, coupon) => {
                                    return (
                                      couponAcc + coupon?.price * coupon?.num
                                    );
                                  },
                                  0,
                                );
                              }
                              return acc;
                            }, 0),
                            '원',
                          )}
                        </Text>
                      </div>
                    </li>
                  </ul>
                </Content>

                {/* 주문목록 */}
                <Content maxWidth={'100%'} padding={0} backgroundColor="none">
                  {orderList?.map((_item, _index) => (
                    <div
                      key={`order_${_item.key}_${_index}`}
                      style={{ margin: '22px 0px' }}
                    >
                      <Text
                        size={16}
                        weight={700}
                        color={'#595959'}
                        style={{ marginBottom: 8 }}
                      >
                        {_item.label}
                      </Text>
                      {_item.data?.map((_subitem) => (
                        <OrderItem
                          key={`order_${_subitem.order_id}`}
                          data={_subitem}
                          onClick={onClose}
                          onSubmit={onSubmit}
                          filterKey={filterKey}
                        />
                      ))}
                    </div>
                  ))}
                </Content>
              </Content>
            </Col>
          </Row>
        </Content>
      ) : (
        <Content
          maxWidth={'100%'}
          padding={0}
          backgroundColor="none"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh', // 화면 높이 기준으로 정 가운데 배치
          }}
        >
          <Button
            type="primary"
            size="large"
            style={{
              width: 200,
              height: 50,
              fontSize: 18,
              fontWeight: 600,
            }}
            onClick={() => {
              onDevice('subscribe');
            }}
          >
            영업 시작
          </Button>
        </Content>
      )}

      <ModalLayout
        type={'drawer'}
        open={isOpened}
        onCancel={onClose}
        title={'주문 상세정보'}
        width={'45%'}
        footer={
          <Content maxWidth={'100%'} padding={0}>
            <Button onClick={() => onClose()}>닫기</Button>
          </Content>
        }
      >
        <Content
          maxWidth={'100%'}
          style={{
            maxHeight: '80vh', // This ensures the content will fit within 70% of the viewport height
            overflowY: 'auto', // Allows vertical scrolling for overflowing content
          }}
        >
          <Row>
            <Col x={24}>
              <Text>주문 정보</Text>

              {/* {console.log('adfasfasd', modalData)} */}
              <Descriptions
                items={[
                  {
                    key: `order_id`,
                    label: `주문번호`,
                    children: `${modalData?.order_id}`,
                  },
                  {
                    key: `order_status`,
                    label: '조리상태',
                    children: (
                      <Tag>
                        {modalData?.order_status === 'READY'
                          ? '대기중'
                          : modalData?.order_status === 'PREPARING'
                            ? '조리중'
                            : modalData?.order_status === 'COMPLETED'
                              ? '완료'
                              : modalData?.order_status === 'DELIVERING'
                                ? '배달중'
                                : modalData?.order_status === 'DELIVERED'
                                  ? '배달완료'
                                  : '취소'}
                      </Tag>
                    ),
                  },
                  {
                    key: `payment_date`,
                    label: '주문시간',
                    children: moment(modalData?.payment_date).format(
                      'YYYY년 MM월 DD일 HH시 mm분',
                    ),
                    // children: moment
                    //   .unix(modalData?.payment_date)
                    //   .format('YYYY년 MM월 DD일 HH시 mm분'),
                  },
                  {
                    key: `over_time`,
                    label: '경과시간',
                    children: moment(modalData?.payment_date)?.fromNow(),
                  },
                  {
                    key: `total_price`,
                    label: '합계금액',
                    children: stringToMoneyFormat(modalData?.totalPrice, '원'),
                  },
                  {
                    key: 'discount',
                    label: '할인/쿠폰',
                    children: stringToMoneyFormat(modalData?.discount, '원'),
                  },
                  {
                    key: 'point',
                    label: '사용포인트',
                    children: stringToMoneyFormat(modalData?.use_point, '원'),
                  },
                  {
                    key: 'payment_state',
                    label: '결제상태',
                    children: (
                      <Select
                        value={modalData?.payment_state}
                        options={PAYMENT_STATE}
                        onChange={(e) =>
                          onUpdatePaymentState(modalData?.order_id, e)
                        }
                      />
                    ),
                  },
                  {
                    key: 'menu',
                    label: '메뉴',
                    style: { padding: 20 },
                    span: 2,
                    children: modalData?.menu?.map((item, index) => (
                      <div
                        key={`menu_${item?.menu_id}`}
                        style={{
                          borderBottom:
                            modalData?.menu.length === index + 1
                              ? 'none'
                              : '1px solid rgba(112, 115, 124, 0.22)',
                          paddingBottom: 10,
                        }}
                      >
                        <div style={{ display: 'flex', marginBottom: 10 }}>
                          <Text
                            size={14}
                            color={'#595959'}
                            align={'left'}
                            style={{ flex: 0.6 }}
                          >
                            {item.menu_name}
                          </Text>
                          <Text
                            size={14}
                            color={'#595959'}
                            style={{ flex: 0.1 }}
                          >
                            {stringToMoneyFormat(item.num, '개')}
                          </Text>
                          <Text
                            size={14}
                            color={'#595959'}
                            align={'right'}
                            style={{ flex: 0.3 }}
                          >
                            {stringToMoneyFormat(item.num * item.price, '원')}
                          </Text>
                        </div>

                        {item.option && (
                          <div style={{ paddingLeft: 20 }}>
                            {item.option?.map((option) => (
                              <div
                                key={option.option_id}
                                style={{ marginBottom: 10 }}
                              >
                                <div
                                  style={{
                                    fontWeight: 'bold',
                                    marginBottom: 5,
                                    textAlign: 'left',
                                  }}
                                >
                                  {option.option_title}
                                </div>
                                <ul
                                  style={{
                                    padding: 0,
                                    margin: 0,
                                    listStyleType: 'none',
                                  }}
                                >
                                  {option.option?.map((opt) => (
                                    <li
                                      key={opt.option_key}
                                      style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        marginBottom: 5,
                                      }}
                                    >
                                      <Text
                                        size={12}
                                        color={'#9A9A9A'}
                                        style={{ flex: 0.6 }}
                                      >
                                        {opt.option_name}
                                      </Text>
                                      <Text
                                        size={12}
                                        color={'#9A9A9A'}
                                        style={{
                                          flex: 0.2,
                                          textAlign: 'right',
                                        }}
                                      >
                                        {opt.count > 0 && `${opt.count}개`}
                                      </Text>
                                      <Text
                                        size={12}
                                        color={'#9A9A9A'}
                                        style={{
                                          flex: 0.2,
                                          textAlign: 'right',
                                        }}
                                      >
                                        {opt.count > 0 &&
                                          `+ ${stringToMoneyFormat(
                                            opt.option_price *
                                              opt.count *
                                              item?.num,
                                            '원',
                                          )}`}
                                      </Text>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    )),
                  },
                  modalType === 'read' && {
                    key: `order_status_button`,
                    label: '주문상태',
                    children: (
                      <div style={{ display: 'flex' }}>
                        {[
                          'READY',
                          'PREPARING',
                          modalData?.type === 'ORDER'
                            ? 'DELIVERING'
                            : 'COMPLETED',
                          modalData?.type === 'ORDER' ? 'DELIVERED' : null,
                          'CANCELLED',
                        ]
                          ?.filter((status) => status)
                          ?.map((status, index) => (
                            <Button
                              key={status}
                              disabled={['REFUNDED', 'ALLORDER'].includes(
                                filterKey,
                              )}
                              style={{
                                ...styles.button,
                                marginLeft: index > 0 ? -2 : 0,
                                background:
                                  modalData?.order_status === status
                                    ? '#0F6CBD'
                                    : '#FFFFFF',
                                color:
                                  modalData?.order_status === status
                                    ? '#FFFFFF'
                                    : '#0F6CBD',
                              }}
                              onClick={() => {
                                handleRefundModal(status);
                                // if (status === 'CANCELLED') {
                                //   const isConfirmed =
                                //     window.confirm('정말 취소하시겠습니까?');
                                //   if (!isConfirmed) return; // 취소를 선택하면 함수 종료
                                // }
                                // onSubmit(
                                //   modalData?.order_route,
                                //   modalData?.order_id,
                                //   status
                                // );
                              }}
                            >
                              {status === 'READY' && '대기중'}
                              {status === 'PREPARING' && '조리중'}
                              {status === 'COMPLETED' && '완료'}
                              {status === 'DELIVERING' && '배달중'}
                              {status === 'DELIVERED' && '배달완료'}
                              {status === 'CANCELLED' && '취소'}
                            </Button>
                          ))}
                      </div>
                    ),
                    style: { padding: 20 },
                  },
                ]}
              />
            </Col>
            <Col x={24}>
              <Text
                style={{
                  paddingTop: 20,
                }}
              >
                주문자 정보
              </Text>
              <Descriptions
                items={[
                  {
                    key: `user_id`,
                    label: `고객 번호`,
                    children: `${modalData?.user?.user_id || '-'}`,
                  },
                  {
                    key: `user_account`,
                    label: '고객 아이디',
                    children: `${modalData?.user?.user_account || '-'}`,
                  },
                  {
                    key: `user_name`,
                    label: '고객 이름',
                    children: `${modalData?.user?.user_name || '-'}`,
                  },
                  {
                    key: 'user_phone',
                    label: '고객 번호',
                    children: `${modalData?.user?.user_phone || '-'}`,
                  },
                  {
                    key: `user_nickname`,
                    label: '고객 닉네임',
                    children: `${modalData?.user?.user_nickname || '-'}`,
                  },
                  {
                    key: `user_gender`,
                    label: '성별',
                    children: `${modalData?.user?.user_gender || '-'}`,
                  },
                ]}
              />

              <div
                style={{
                  marginTop: 10,
                  display: 'flex',
                  justifyContent:
                    modalType === 'read' ? 'flex-start' : 'flex-end',
                }}
              ></div>
            </Col>
            {modalData?.coupon_info?.length > 0 && (
              <>
                <Col x={24}>
                  <Text
                    style={{
                      paddingTop: 20,
                    }}
                  >
                    쿠폰/할인 정보
                  </Text>
                  {modalData?.coupon_info?.map((coupon) => (
                    <Descriptions
                      items={[
                        {
                          key: `coupon_user_id`,
                          label: `쿠폰함 번호`,
                          children: `${coupon?.coupon_user_id || '-'}`,
                        },
                        {
                          key: `coupon_type`,
                          label: `쿠폰 타입`,
                          children: `${coupon?.coupon_type || '-'}`,
                        },
                        {
                          key: `coupon_name`,
                          label: `쿠폰명`,
                          children: `${coupon?.coupon_name || '-'}`,
                        },
                        {
                          key: `discount_price`,
                          label: '할인 금액',
                          children: `${
                            stringToMoneyFormat(coupon?.discount_price) || '-'
                          }`,
                        },
                      ]}
                    />
                  ))}
                </Col>
              </>
            )}

            {modalData?.present_info?.length > 0 && (
              <>
                <Col x={24}>
                  <Text
                    style={{
                      paddingTop: 20,
                    }}
                  >
                    선물쿠폰 정보
                  </Text>
                  {modalData?.present_info?.map((coupon, index) => (
                    <Descriptions
                      key={`present_${coupon?.present_id}_${index}`}
                      ratio={[20, 30, 20, 30]}
                      items={[
                        {
                          key: `present_id`,
                          label: `선물 쿠폰함 번호`,
                          children: `${coupon?.present_id || '-'}`,
                        },
                        {
                          key: `menu_name`,
                          label: `메뉴명`,
                          children: `${coupon?.menu_name || '-'}`,
                        },
                        {
                          key: `할인금액`,
                          label: `할인금액`,
                          children: `-${
                            stringToMoneyFormat(coupon?.price * coupon?.num) ||
                            '-'
                          }`,
                        },
                        {
                          key: `사용수량`,
                          label: '사용수량',
                          children: `${
                            stringToMoneyFormat(coupon?.num) || '-'
                          }`,
                        },
                      ]}
                    />
                  ))}
                </Col>
              </>
            )}
          </Row>
        </Content>
      </ModalLayout>

      {/* 환불 사유 입력 모달 */}
      <ModalLayout
        title="환불 사유 입력"
        open={isRefundModalOpen}
        onCancel={() => setIsRefundModalOpen(false)}
        footer={
          <Content maxWidth={'100%'} padding={0}>
            <Button onClick={() => setIsRefundModalOpen(false)}>닫기</Button>
            <Button type="primary" onClick={() => handleRefundSubmit()}>
              주문취소
            </Button>
          </Content>
        }
      >
        <Input
          placeholder="환불 사유를 입력해주세요"
          value={refundReason}
          onChange={(e) => setRefundReason(e.target.value)}
        />
      </ModalLayout>
    </>
  );
};

export default OrderListPresenter;
